export const SEO_BRAND = "Virtus AI";
export const SEO_PRODUCT = "Social Media Manager";
export const SEO_TITLE_SUFFIX = `${SEO_BRAND} | ${SEO_PRODUCT}`;

/**
 * Monta o título da aba com o padrão de marca e produto.
 * Retorna apenas o sufixo padrão caso não haja título específico.
 */
export const formatPageTitle = (pageTitle?: string) => {
  const normalizedTitle = pageTitle?.trim();
  if (!normalizedTitle) {
    return SEO_TITLE_SUFFIX;
  }

  return `${normalizedTitle} | ${SEO_TITLE_SUFFIX}`;
};
